import initializeComponent from 'Shared/react-initialize';
import Announcements from './announcements';

initializeComponent('Announcements', Announcements);
